//
// Copyright (c) 2025 Comcast
//

import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import { uniqueId } from 'utils/strings'

const StyledIconLink = styled(IconLink)`
  padding: 4px;
  margin-left: 2px;
  position: relative;
  top: 1px;
`

const ExpandRowIcon = ({ isExpanded, onExpandToggle, tooltipText }) => {
  const id = useMemo(() => uniqueId(), [])
  const tooltipId = `expand-tooltip-${id}`

  const onClick = (e) => {
    if (onExpandToggle) {
      e.stopPropagation()
      onExpandToggle()
    }
  }

  return (
    <>
      <StyledIconLink
        iconName={isExpanded ? 'icon-arrow-down-small-12' : 'icon-arrow-right-12'}
        onClick={onClick}
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipText}
      />
      {!!tooltipText && <Tooltip id={tooltipId} />}
    </>
  )
}

ExpandRowIcon.propTypes = {
  isExpanded: PropTypes.bool,
  onExpandToggle: PropTypes.func,
  tooltipText: PropTypes.string,
}

export default ExpandRowIcon
